var map = {
	"./bi.png": "9ffb",
	"./consumer.png": "f4c8",
	"./payment.png": "eac1",
	"./retail.jpg": "3b7b",
	"./tourism.png": "93c9",
	"./transportation.png": "d95d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "636c";